import type {
  SystemDateFormat,
  SystemSettingPublic,
  SystemTimeFormat,
} from '@/shared/types/system-setting.type'
import { readStoredAuthSession } from '@/stores/auth.store'

export const PUBLIC_SYSTEM_SETTINGS_STORAGE_KEY = 'bigsale.system-settings.public'

function storageKey(tenantCode?: string | null) {
  const code = tenantCode ?? readStoredAuthSession()?.tenant?.code ?? null
  return code
    ? `${PUBLIC_SYSTEM_SETTINGS_STORAGE_KEY}.${code.toLowerCase()}`
    : PUBLIC_SYSTEM_SETTINGS_STORAGE_KEY
}

const SYSTEM_DATE_FORMATS: readonly SystemDateFormat[] = ['DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY-MM-DD']
const SYSTEM_TIME_FORMATS: readonly SystemTimeFormat[] = ['24h', '12h']

export function readStoredPublicSystemSettings(
  tenantCode?: string | null,
): SystemSettingPublic | null {
  if (typeof localStorage === 'undefined') return null

  try {
    const raw = localStorage.getItem(storageKey(tenantCode))
    return raw ? (JSON.parse(raw) as SystemSettingPublic) : null
  } catch {
    return null
  }
}

export function writeStoredPublicSystemSettings(
  settings: SystemSettingPublic,
  tenantCode?: string | null,
): void {
  if (typeof localStorage === 'undefined') return
  localStorage.setItem(storageKey(tenantCode), JSON.stringify(settings))
}

export function getStoredSystemDateFormat(
  fallback: SystemDateFormat = 'DD/MM/YYYY',
): SystemDateFormat {
  const format = readStoredPublicSystemSettings()?.date_format
  return format && SYSTEM_DATE_FORMATS.includes(format) ? format : fallback
}

export function getStoredSystemTimeFormat(fallback: SystemTimeFormat = '24h'): SystemTimeFormat {
  const format = readStoredPublicSystemSettings()?.time_format
  return format && SYSTEM_TIME_FORMATS.includes(format) ? format : fallback
}
